import script from "./StatusSettingsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusSettingsTable.vue?vue&type=script&setup=true&lang=js"

import "./StatusSettingsTable.vue?vue&type=style&index=0&id=274acc96&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-274acc96"]])

export default __exports__